import React, { useEffect, useRef, useState } from "react";
import { FaSearch, FaGlobe, FaUser, FaBars, FaTimes, FaArrowRight, FaChevronDown, FaLaptopCode, FaMobileAlt, FaShopify, FaBullhorn, FaPencilRuler, FaVideo, FaCloudUploadAlt, FaDatabase, FaRobot, FaBrain, FaShieldAlt, FaChartPie, FaServer, FaPhone, FaEnvelope, FaGithub } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.jpeg";
import developer from "../assets/mainLogo.png";
import searchItems from "../data/searchItems";

const NavigationSection = () => {
  const [showSearch, setShowSearch] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [showMap, setShowMap] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [showDevInfo, setShowDevInfo] = useState(false);
  const searchRef = useRef(null);
  const productsRef = useRef(null);
  const navigate = useNavigate();
  
const LOGIN_API = "https://erp.sapeagleerp.com/login";

  useEffect(() => {
    const handleScroll = () => {

      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (showSearch && searchRef.current) {
      searchRef.current.focus();
    }
  }, [showSearch]);

  useEffect(() => {
    if (showSearch || showMap || menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [showSearch, showMap, menuOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (productsRef.current && !productsRef.current.contains(event.target)) {
        setProductsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setQuery(value);

    if (value.length > 0) {
      const filtered = searchItems.filter((item) =>
        item.name.toLowerCase().includes(value)
      );
      setResults(filtered);
    } else {
      setResults([]);
    }
  };

  const handleSelect = (path) => {
    setShowSearch(false);
    setQuery("");
    setResults([]);
    navigate(path);
  };

  const products = [
    { name: "Web Development", desc: "Custom websites & web apps", icon: <FaLaptopCode />, path: "/", color: "from-blue-500 to-blue-700" },
    { name: "Mobile Apps", desc: "iOS & Android applications", icon: <FaMobileAlt />, path: "/", color: "from-purple-500 to-purple-700" },
    { name: "E-Commerce", desc: "Online store solutions", icon: <FaShopify />, path: "/", color: "from-green-500 to-green-700" },
    { name: "Digital Marketing", desc: "SEO, social media & ads", icon: <FaBullhorn />, path: "/", color: "from-orange-500 to-orange-700" },
    { name: "UI/UX Design", desc: "Creative design services", icon: <FaPencilRuler />, path: "/", color: "from-pink-500 to-pink-700" },
    { name: "Video Editing", desc: "Professional video production", icon: <FaVideo />, path: "/", color: "from-red-500 to-red-700" },
    { name: "Cloud Solutions", desc: "Cloud hosting & storage", icon: <FaCloudUploadAlt />, path: "/", color: "from-cyan-500 to-cyan-700" },
    { name: "Data Analytics", desc: "Business intelligence", icon: <FaChartPie />, path: "/", color: "from-indigo-500 to-indigo-700" },
    { name: "AI Solutions", desc: "Machine learning & AI", icon: <FaRobot />, path: "/", color: "from-amber-500 to-amber-700" },
    { name: "Cyber Security", desc: "Security & protection", icon: <FaShieldAlt />, path: "/", color: "from-teal-500 to-teal-700" },
    { name: "Backend Dev", desc: "Server & database", icon: <FaServer />, path: "/", color: "from-slate-500 to-slate-700" },
    { name: "Consulting", desc: "Tech & business advisory", icon: <FaBrain />, path: "/", color: "from-violet-500 to-violet-700" },
  ];

  const navLinks = [
    { name: "Services", path: "/", hasDropdown: true },
    { name: "Industries", path: "/industories" },
    { name: "Features", path: "/explore-our-services" },
    { name: "Pricing", path: "/pricing" },
    { name: "Customers", path: "/customers" },
    { name: "Supports", path: "/support" },
  ];

  return (
    <>
      <nav
        className={`sticky top-0 z-50 transition-all duration-500 ${
          scrolled ? "bg-white/98 backdrop-blur-xl shadow-xl" : "bg-white shadow-lg"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-24">

            {/* LOGO WITH HOVER */}
            <div 
              className="relative"
              onMouseEnter={() => setShowDevInfo(true)}
              onMouseLeave={() => setShowDevInfo(false)}
            >
              <Link to="/" className="group">
                <img
                  src={logo}
                  alt="Logo"
                  className="h-[90px] w-[120px] object-contain transition-transform duration-500 group-hover:scale-110"
                />
              </Link>

            
            </div>

            {/* DESKTOP LINKS */}
            <div className="hidden lg:flex items-center gap-1">
              {navLinks.map((link) => (
                <div
                  key={link.name}
                  ref={link.name === "Services" ? productsRef : null}
                  className="relative"
                >
                  {link.hasDropdown ? (
                    <button
                      onMouseEnter={() => setProductsOpen(true)}
                      className="flex items-center gap-2 px-5 py-3 text-base font-semibold text-gray-800 hover:text-blue-600 transition-all duration-300"
                    >
                      {link.name}
                      <FaChevronDown className={`text-xs transition-transform duration-300 ${productsOpen ? "rotate-180 text-blue-600" : ""}`} />
                    </button>
                  ) : (
                    <Link
                      to={link.path}
                      className="px-5 py-3 text-base font-semibold text-gray-800 hover:text-blue-600 transition-all duration-300 relative group"
                    >
                      {link.name}
                      <span className="absolute bottom-2 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-blue-600 to-purple-600 transition-all duration-300 group-hover:w-full" />
                    </Link>
                  )}
                </div>
              ))}
            </div>

            {/* RIGHT ICONS */}
            <div className="flex items-center gap-2">
              <button
                onClick={() => setShowSearch(true)}
                className="flex items-center justify-center w-10 h-10 hover:bg-gray-100 rounded-full transition-all duration-200 group"
                aria-label="Search"
              >
                <FaSearch className="text-gray-600 w-4 h-4 group-hover:text-blue-600" />
              </button>

              <button
                className="hidden sm:flex items-center justify-center w-10 h-10 hover:bg-gray-100 rounded-full transition-all duration-200 group"
                onClick={() => setShowMap(true)}
                aria-label="Map"
              >
                <FaGlobe className="text-gray-600 w-4 h-4 group-hover:text-blue-600" />
              </button>

              <Link
                to={LOGIN_API}
                className="hidden md:flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-gray-700 hover:text-blue-600 bg-gray-100 hover:bg-blue-50 rounded-full"
              >
                <FaUser className="w-3.5 h-3.5" />
                Login
              </Link>

              <button className="hidden sm:block bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 hover:shadow-xl text-white px-6 py-3 rounded-full font-semibold text-sm transition-all duration-300 hover:-translate-y-0.5">
                <Link to="/book-demo-section">Get Started</Link>
              </button>

              <button
                onClick={toggleMenu}
                className="lg:hidden flex items-center justify-center w-10 h-10 hover:bg-gray-100 rounded-full"
              >
                {menuOpen ? (
                  <FaTimes className="text-gray-700 w-5 h-5" />
                ) : (
                  <FaBars className="text-gray-700 w-5 h-5" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* SERVICES DROPDOWN */}
        <div
          onMouseEnter={() => setProductsOpen(true)}
          onMouseLeave={() => setProductsOpen(false)}
          className={`absolute left-0 right-0 top-full bg-white/98 backdrop-blur-xl border-t-4 border-gradient-to-r from-blue-600 via-purple-600 to-pink-600 shadow-2xl transition-all duration-300 ${
            productsOpen ? "opacity-100 visible translate-y-0" : "opacity-0 invisible -translate-y-4 pointer-events-none"
          }`}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                Our Extra  Services
              </h3>
              <p className="text-gray-500 mt-2">Professional solutions for your business needs</p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {products.map((product, index) => (
                <Link
                  key={index}
                  to={product.path}
                  onClick={() => setProductsOpen(false)}
                  className="group relative bg-gradient-to-b from-gray-50 to-white p-5 rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-transparent"
                >
                  <div className={`absolute inset-0 bg-gradient-to-br ${product.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl`} />
                  
                  <div className="relative z-10 flex flex-col items-center text-center">
                    <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${product.color} flex items-center justify-center mb-3 shadow-lg group-hover:scale-125 group-hover:rotate-6 transition-all duration-300`}>
                      <span className="text-white text-2xl">{product.icon}</span>
                    </div>
                    <h3 className="font-bold text-gray-800 group-hover:text-white transition-colors duration-300 text-sm">
                      {product.name}
                    </h3>
                    <p className="text-xs text-gray-500 group-hover:text-white/80 mt-1 transition-colors duration-300">
                      {product.desc}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
            
            <div className="mt-8 pt-6 border-t border-gray-200 flex justify-center">
              <Link
                to="/explore-our-services"
                onClick={() => setProductsOpen(false)}
                className="flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-2xl font-bold hover:shadow-2xl transition-all duration-300 hover:scale-105"
              >
                View All Services
                <FaArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* SEARCH OVERLAY */}
      <div className={`fixed inset-0 z-[9999] transition-all duration-300 ${showSearch ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"}`}>
        <div className="absolute inset-0 bg-black/50 backdrop-blur-md" onClick={() => setShowSearch(false)} />

        <div className={`relative w-full max-w-2xl mx-auto mt-32 px-4 ${showSearch ? "translate-y-0 opacity-100" : "-translate-y-4 opacity-0"}`}>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">
              <FaSearch className="text-gray-400 w-5 h-5" />
            </div>
            <input
              ref={searchRef}
              type="text"
              value={query}
              onChange={handleSearch}
              placeholder="Search for services, pages..."
              className="w-full pl-14 pr-32 py-4 text-lg bg-white border-0 rounded-2xl shadow-2xl focus:outline-none focus:ring-4 focus:ring-blue-500/20"
            />
            <button onClick={() => setShowSearch(false)} className="absolute right-3 top-1/2 -translate-y-1/2 px-4 py-1.5 bg-gray-100 rounded-full text-sm">
              ESC
            </button>
          </div>

          <div className="mt-4">
            {results.length > 0 && (
              <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
                <ul className="max-h-80 overflow-y-auto">
                  {results.map((item, i) => (
                    <li key={i} className="px-5 py-3.5 hover:bg-blue-50 cursor-pointer flex items-center justify-between" onClick={() => handleSelect(item.path)}>
                      <span className="text-gray-700 font-medium">{item.name}</span>
                      <FaArrowRight className="text-gray-300 w-3 h-3" />
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* MAP OVERLAY */}
      <div className={`fixed inset-0 z-[9999] flex items-center justify-center p-4 transition-all duration-300 ${showMap ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"}`}>
        <div className="absolute inset-0 bg-black/50 backdrop-blur-md" onClick={() => setShowMap(false)} />
        <div className={`relative w-full max-w-5xl h-[80vh] bg-white rounded-2xl shadow-2xl overflow-hidden ${showMap ? "scale-100" : "scale-95"}`}>
          <div className="absolute top-0 left-0 right-0 z-10 bg-gradient-to-b from-black/60 to-transparent p-6 pb-12">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-white text-xl font-semibold">Our Location</h3>
                <p className="text-white/80 text-sm mt-1">Visit us at our headquarters</p>
              </div>
              <button onClick={() => setShowMap(false)} className="p-2 bg-white/20 rounded-full">
                <FaTimes className="text-white w-5 h-5" />
              </button>
            </div>
          </div>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.902988654204!2d90.398197!3d23.780887!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c7c38b4e1f27%3A0xa4e2a22712345678!2sYour%20Company%20Location!5e0!3m2!1sen!2sin!4v1600000000000!5m2!1sen!2sin" width="100%" height="100%" className="rounded-t-2xl" style={{ border: 0 }} allowFullScreen="" loading="lazy"></iframe>
        </div>
      </div>

      {/* MOBILE MENU */}
      <div className={`fixed inset-0 z-[9998] transition-opacity duration-300 ${menuOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}>
        <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setMenuOpen(false)} />
        <div className={`absolute top-0 right-0 w-full sm:w-[420px] h-full bg-white shadow-2xl transition-transform duration-500 ${menuOpen ? "translate-x-0" : "translate-x-full"}`}>
          <div className="flex items-center justify-between p-6 bg-gradient-to-r from-blue-600 to-purple-600">
            <img src={logo} alt="Logo" className="h-10 w-auto" />
            <button onClick={() => setMenuOpen(false)} className="p-2 bg-white/20 rounded-full">
              <FaTimes className="text-white w-5 h-5" />
            </button>
          </div>
          <div className="flex flex-col p-6 overflow-y-auto h-[calc(100%-80px)]">
            <div className="space-y-2">
              {navLinks.map((link, index) => (
                <Link key={index} to={link.path} onClick={() => setMenuOpen(false)} className="flex items-center justify-between px-4 py-4 text-gray-800 hover:bg-blue-50 rounded-xl font-bold text-lg">
                  {link.name} {link.hasDropdown ? <FaChevronDown className="text-gray-400" /> : <FaArrowRight className="text-gray-400" />}
                </Link>
              ))}
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200">
              <p className="text-xs font-bold text-gray-400 uppercase mb-4">All Services</p>
              <div className="grid grid-cols-2 gap-3">
                {products.map((product, index) => (
                  <Link key={index} to={product.path} onClick={() => setMenuOpen(false)} className="flex flex-col items-center gap-2 p-3 bg-gray-50 hover:bg-blue-50 rounded-xl text-center">
                    <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${product.color} flex items-center justify-center`}>
                      <span className="text-white">{product.icon}</span>
                    </div>
                    <span className="text-xs font-bold text-gray-700">{product.name}</span>
                  </Link>
                ))}
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200 space-y-3">
              <Link to="/login" onClick={() => setMenuOpen(false)} className="flex items-center justify-center gap-2 w-full py-4 bg-gray-100 font-bold rounded-xl">
                <FaUser /> Login
              </Link>
              <Link to="/book-demo-section" onClick={() => setMenuOpen(false)} className="flex items-center justify-center gap-2 w-full py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold rounded-xl">
                Get Started <FaArrowRight />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavigationSection;
